import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { getNavMenuItems } from '../../constants';

/**
 * Admin Sidebar Component
 * Navigation sidebar with collapsible menu
 * @param {Object} props - Component props
 * @param {boolean} props.collapsed - Whether sidebar is collapsed
 * @param {Function} props.onToggle - Toggle sidebar handler
 */
const AdminSidebar = ({ collapsed, onToggle }) => {

  return (
    <aside className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          {!collapsed && <span>WeSplit Admin</span>}
        </div>
        <button 
          className="sidebar-toggle"
          onClick={onToggle}
          aria-label="Toggle sidebar"
        >
          {collapsed ? (
            <i className="bi bi-chevron-right icon-brand"></i>
          ) : (
            <i className="bi bi-chevron-left icon-brand"></i>
          )}
        </button>
      </div>
      
      <nav className="sidebar-nav" aria-label="Main navigation">
        <ul className="nav-list">
          {(() => {
            const navItems = getNavMenuItems();
            let currentGroup = null;

            return navItems.map((item, index) => {
              const showGroupHeader = item.group && item.group !== currentGroup;
              if (showGroupHeader) {
                currentGroup = item.group;
              }

              return (
                <React.Fragment key={item.path || `divider-${index}`}>
                  {showGroupHeader && !collapsed && (
                    <li className="nav-group-header">
                      <span>{item.group}</span>
                    </li>
                  )}
                  {item.type === 'link' && (
                    <li className="nav-item">
                      <NavLink
                        to={item.path}
                        className={({ isActive }) =>
                          `nav-link ${isActive ? 'active' : ''}`
                        }
                        title={collapsed ? item.label : ''}
                      >
                        <i className={`nav-icon bi ${item.iconClass} icon-brand`}></i>
                        {!collapsed && <span className="nav-label">{item.label}</span>}
                      </NavLink>
                    </li>
                  )}
                </React.Fragment>
              );
            });
          })()}
        </ul>
      </nav>
    </aside>
  );
};

AdminSidebar.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default AdminSidebar;
